import script from "./HorizontalScrollBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./HorizontalScrollBox.vue?vue&type=script&setup=true&lang=ts"

import "./HorizontalScrollBox.vue?vue&type=style&index=0&id=5c6756b9&lang=scss"

const __exports__ = script;

export default __exports__